import { Scale } from "lucide-react";
import { SettledRules } from "@/components/ui/SettledRules";

/**
 * Ba quy tắc của Đơn vị & bảng giá — anh Toàn chốt 19/09/2026 theo chuẩn ERP (UOM-R01..R03), khách bác lại được. Trước đây là ba thẻ
 * vàng "chờ khách xác nhận"; nay là một mục gập trung tính để người dùng tra khi cần.
 */
export function UnitPricingRules() {
  return <div className="my-4"><SettledRules ns="unitPricing" rules={["conversion", "pricing", "approval"]} icon={Scale} /></div>;
}
